import { render, staticRenderFns } from "./CarouselItemsOfertVertical.vue?vue&type=template&id=6010aff9"
import script from "./CarouselItemsOfertVertical.vue?vue&type=script&lang=js"
export * from "./CarouselItemsOfertVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports